import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import * as Sentry from '@sentry/react';
import { CaptureConsole } from '@sentry/integrations';

import 'semantic-ui-css/semantic.min.css';
import './index.css';

import ScrollToTop from './ScrollToTop';
import Header from './Header';
import Footer from './Footer';
import LandingPage from './LandingPage/';
import Form from './Form/';
import Thanks from './Thanks/';
import getStringsFromContentful from './getStringsFromContentful';

Sentry.init({
  dsn:
    'https://242760f93b3240018c05244662581493@o439619.ingest.sentry.io/5455892',
  integrations: [new CaptureConsole({ levels: ['log', 'error'] })],
  tracesSampleRate: 1.0,
});

getStringsFromContentful
  .then((strings) => {
    const {
      LandingPageStrings,
      FormPageStrings,
      ThanksStrings,
    } = strings.fields.data;

    ReactDOM.render(
      <Router>
        <ScrollToTop>
          <div>
            <Header />
            <Route
              exact
              path="/"
              render={(props) => (
                <LandingPage {...props} {...LandingPageStrings} />
              )}
            />
            <Route
              path="/innmelding"
              render={(props) => <Form {...props} {...FormPageStrings} />}
            />
            <Route
              path="/takk"
              render={(props) => <Thanks {...props} {...ThanksStrings} />}
            />
            <Footer />
          </div>
        </ScrollToTop>
      </Router>,
      document.getElementById('root')
    );
  })
  .catch((error) => {
    ReactDOM.render(
      <div style={{ textAlign: 'center' }}>
        <h1>Feil!</h1>
        <p>Klarte ikke laste inn siden. Prøv å laste den inn på nytt.</p>
      </div>,
      document.getElementById('root')
    );

    console.log(error);
  });



// WEBPACK FOOTER //
// ./src/index.js